import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";
import { standardReducer } from "@/store/utils.js";

const accessFeaturesReducer = createAsyncReducer({
  name: 'accessFeatures',
  initialState: {
    records: {},
    loading: false,
    errorMessage: ''
  },
  reducers: (create) => ({
    loadAll: create.asyncThunk(
      async () => {
        return Fetch.get(Routes.ajax_access_features_path());
      },
      standardReducer
    ),
    loadOne: create.asyncThunk(
      async ({ id }) => {
        return Fetch.get(Routes.ajax_access_feature_path(id));
      },
      standardReducer
    ),
    display: create.asyncThunk(
      async ({ id, code }) => {
        return Fetch.get(Routes.ajax_access_feature_display_path(id, { code }));
      },
      standardReducer
    )
  })
});

export default accessFeaturesReducer;